import type { Transition, Variants } from "framer-motion";

export const fadeInOutVariants: Variants = {
  enter: { opacity: 0 },
  center: { opacity: 1 },
  exit: {
    opacity: 0,
  },
};

export const horizontalFadeVariants: Variants = {
  enter: { x: 1000, opacity: 0 },
  center: { zIndex: 1, x: 0, opacity: 1 },
  exit: {
    zIndex: 0,
    x: -1000,
    opacity: 0,
  },
};

export const fadeInOutTransition: Transition = {
  opacity: { duration: 0.15 },
};

export const horizontalFadeTransition: Transition = {
  x: {
    type: "easeOut",
    stiffness: 300,
    damping: 30,
    duration: 0.15,
  },
  opacity: { duration: 0.1 },
};
